export default function CheckboxIcon() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.4375 6.125L6.85414 10.5L4.5625 8.3125M1.75 1.125H14.25C14.5952 1.125 14.875 1.40482 14.875 1.75V14.25C14.875 14.5952 14.5952 14.875 14.25 14.875H1.75C1.40482 14.875 1.125 14.5952 1.125 14.25V1.75C1.125 1.40482 1.40482 1.125 1.75 1.125Z"
        stroke="#455468"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
